import React, { useCallback, useState } from 'react';

import { Icon } from 'ui';

import TopicRankingDetail from '../TopicRankingDetail/TopicRankingDetail';
import './_topic-ranking-item.scss';

type TopicRankingItemProps = {
  colorIndex: number;
  courseIds: string[];
  disciplineName: string;
  endDate: string | undefined;
  frequency: number;
  maxFrequency: number;
  startDate: string | undefined;
  topic: string;
  topicId: string | null;
};

function TopicRankingItem({ colorIndex, courseIds, disciplineName, endDate, frequency, maxFrequency, startDate, topic, topicId }: TopicRankingItemProps): JSX.Element {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const colorNumber = (colorIndex % 8) + 1;
  const barWidthPercent = maxFrequency > 0 ? (frequency / maxFrequency) * 100 : 0;

  const handleToggle = useCallback((e: React.MouseEvent) => {
    e.stopPropagation();
    setIsExpanded((prev) => !prev);
  }, []);

  return (
    <div className={`topic-ranking-item topic-ranking-item--color-${colorNumber}`}>
      <div className="topic-ranking-item__row" onClick={handleToggle}>
        <div className="topic-ranking-item__info">
          <span className="topic-ranking-item__name">{topic}</span>
          {disciplineName && <span className="topic-ranking-item__discipline-badge">{disciplineName}</span>}
        </div>
        <div className="topic-ranking-item__actions">
          <span className="topic-ranking-item__frequency">{frequency}</span>
          <button
            aria-label={isExpanded ? 'Collapse' : 'Expand'}
            className={`topic-ranking-item__chevron ${isExpanded ? 'topic-ranking-item__chevron--expanded' : ''}`}
            onClick={handleToggle}
            type="button"
          >
            <Icon name="chevron-down" size="md" />
          </button>
        </div>
      </div>
      <div className="topic-ranking-item__bar">
        <div className="topic-ranking-item__bar-fill" style={{ width: `${barWidthPercent}%` }} />
      </div>
      <TopicRankingDetail
        colorIndex={colorIndex}
        courseIds={courseIds}
        endDate={endDate}
        frequency={frequency}
        isExpanded={isExpanded}
        startDate={startDate}
        topicId={topicId}
      />
    </div>
  );
}

export default TopicRankingItem;
